import React from 'react';
import Pagination from './Pagination';
import { useEffect, useState } from 'react';
import Link from 'next/link';
// import './reuseTable.scss';
import axios from 'axios';
import dateFormatChange, { dateChangeWithSeconds } from './dateFormatChange';
import AddRejectNote from '../Components/HistoricalData/addRejectNote';
import ExpandRejectNote from '../Components/HistoricalData/expandRejectNote';
import { toast } from 'react-toastify';
import IsActiveModal from '../Components/merchants/isactiveConformation';
import ExpandRefundDescription from './expandRefundDecription';
import CheckRadioButton from './checkRadioInputs';
import ProviderDropDownInput from '../Components/PaymentProviderSwitch/providerDropDownInput';
import { useSelector } from 'react-redux';
import { sanitizeStringWhiteSpace } from '../utils/sanitizeString';
import Image from 'next/image';
import ShowMoreButton from './showMoreButton';
import { SwitchInput } from './reuseAbleInputs';
import { stringMonthDate } from './dateFormat';

const ReuseTable = ({
  colomnsName,
  colomns,
  data,
  setData,
  totalCount,
  setPageSize,
  pageSize,
  page,
  setPage,
  pages,
  setSearchFlag,
  from,
  displayModal,
  setPreview,
  openModal,
  actionFunctions,
  rowsChecked,
  setRowsChecked,
  refundInitiate,
  newDesign,
  customComponents,
  customData,
  hideShowMore,
}) => {
  let token = localStorage.getItem('token');

  const headers = {
    'Content-Type': 'application/json',
    authorization: token,
  };
  const [pageNumbers, setPageNumbers] = useState();
  const [displayPages, setDisplayPages] = useState([]);
  const [historicalDataID, setHistoricalDataID] = useState('');
  const [refundDescription, setRefundDescription] = useState('');
  const [showMore, setShowMore] = useState(colomnsName.length >= 10 ? false : true);
  const nullToStr = (str, last) => {
    if (!str) return '';
    if (last) return str;
    return str + ', ';
  };
  const [activeRow, setActiveRow] = useState(null);
  const permissions = useSelector((state) => state.user.permissions);
  const paymentMSConfig = useSelector((state) => state.paymentInterface.data);
  const findAddress = (data) => {
    let Address;
    if (data['Address.address']) {
      Address = nullToStr(data['Address.address']);
    } else {
      Address = nullToStr(data['Address.address1']) + nullToStr(data['Address.address2']);
    }

    Address =
      Address +
      nullToStr(data['Address.city']) +
      nullToStr(data['Address.state']) +
      nullToStr(data['Address.pincode'], 1);
    return sanitizeStringWhiteSpace(Address);

    // return Address;
  };

  const numberWithCommas = (x) => {
    // var x = 12345652457.557;
    // x = x.toString();
    var afterPoint = '';
    if (x.indexOf('.') > 0) afterPoint = x.substring(x.indexOf('.'), x.length);
    x = Math.floor(x);
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers != '') lastThree = ',' + lastThree;
    return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree + afterPoint;

    // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  };

  const formatFileNameBulkRefund = (file, id) => {
    if (file === null) return '';
    let temp = `merchant/${id}/`;
    let final = file.replace(temp, '');
    return final;
  };

  useEffect(() => {
    let pageNumber = [];
    for (let i = 1; i <= pages; i++) {
      pageNumber.push(i);
    }
    setPageNumbers(pageNumber);
    let temp = Math.floor((page - 1) / 5) * 5;
    setDisplayPages(pageNumber.slice(temp, temp + 5));
  }, [pages, page]);

  const next = () => {
    let alldisplayPages = [...displayPages];
    let lastPage = alldisplayPages.pop();
    let allPages = [...pageNumbers];
    if (lastPage == allPages.pop()) {
      return;
    }
    setPage(lastPage + 1);
    setDisplayPages(pageNumbers.slice(lastPage, lastPage + 5));
  };

  const previous = () => {
    let alldisplayPages = [...displayPages];
    let firstPage = alldisplayPages.shift();
    let allPages = [...pageNumbers];
    if (firstPage == allPages.shift()) {
      return;
    }
    setPage(firstPage - 1);
    setDisplayPages(pageNumbers.slice(firstPage - 6, firstPage - 1));
  };

  // const [continueSubmitFlag, setContinueSubmitFlag] = useState(false);
  // useEffect(() => {
  //   if (continueSubmitFlag) set();
  // }, [continueSubmitFlag]);

  const [merchantId, setMerchantID] = useState('');
  const [eventObject, setEventObject] = useState(false);

  const closeIsActiveModal = () => {
    document.getElementById('go-modal-isactive').classList.remove('open');
  };
  const OpenIsActiveModal = () => {
    document.getElementById('go-modal-isactive').classList.add('open');
  };

  const shopifyMerchantActive = (e, merchantId) => {
    let tempState = '';
    if (e.target.checked) tempState = 'enable';
    else tempState = 'disable';
    axios
      .post(
        process.env.BASE_URL + '/api/shopify/app-state',
        { mid: merchantId, state: tempState },
        {
          headers: headers,
        }
      )
      .then((res) => {
        toast.success('Operation Successfull', {
          position: 'top-center',
          autoClose: 1500,
        });
      })
      .catch(() => {
        toast.error('Operation Failed', {
          position: 'top-center',
          autoClose: 1500,
        });
      });
  };
  const getBase64 = async (url) => {
    try {
      let res = await axios.get(process.env.BASE_URL + `/api/utility/download?url=${url}`, {
        headers: {
          authorization: localStorage.getItem('token'),
        },
      });
      console.log('download', res.data.data.file.data);
      const base64String = btoa(
        new Uint8Array(res.data.data.file.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return base64String;
    } catch (err) {
      console.log('downloadimg error', err);
    }
  };
  const getType = (type) => {
    switch (type) {
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'png':
        return 'image/png';
      case 'jpg':
        return 'image/jpg';
      case 'jpeg':
        return 'image/jpeg';
      case 'svg':
        return 'image/svg+xml';
      default:
        return '';
    }
  };
  const allCheck = (e) => {
    let temp = [...data];
    let mids = [];
    if (e.target.checked) {
      temp.forEach((merchant) => {
        merchant.checked = true;
        mids.push(merchant.m_id);
      });
    } else {
      temp.forEach((merchant) => {
        merchant.checked = false;
      });
    }
    setData([...temp]);
    setRowsChecked([...mids]);
  };

  const bodyCheck = (checked, id) => {
    const tempData = [...data];
    console.log(rowsChecked);
    let tempRowsChecked = [...rowsChecked];
    if (checked) {
      tempData.find((merchant) => (merchant.m_id === id ? (merchant.checked = true) : null));
      !tempRowsChecked.includes(id) ? (tempRowsChecked = [...tempRowsChecked, id]) : null;
    } else {
      tempData.find((merchant) => (merchant.m_id === id ? (merchant.checked = false) : null));
      tempRowsChecked = [...tempRowsChecked.filter((data) => data !== id)];
    }
    setData([...tempData]);
    setRowsChecked([...tempRowsChecked]);
  };
  const downloadSourceFile = (url) => {
    let base64prom = getBase64(url);
    const [, type] = url.split('.');
    base64prom.then((res) => {
      if (type === 'pdf' || type === 'doc') {
        const linkSource = `data:${getType(type)};base64,${res}`;
        const downloadLink = document.createElement('a');
        const fileName = `document.${type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      } else setPreview(res);
    });
  };

  const customerBlock = (e, customerId) => {
    axios
      .post(
        process.env.BASE_URL + '/api/customer/block',
        { customerId: customerId, is_blocked: e.target.checked },
        {
          headers: headers,
        }
      )
      .then((res) => {
        toast.success('Operation Successfull', {
          position: 'top-center',
          autoClose: 1500,
        });
      })
      .catch(() => {
        toast.error('Operation Failed', {
          position: 'top-center',
          autoClose: 1500,
        });
      });
  };

  const deleteCustomer = (customerId) => {
    axios
      .post(
        process.env.BASE_URL + `/api/customer/delete/${customerId}`,
        { id: customerId },
        {
          headers: headers,
        }
      )
      .then(() => {
        toast.success('Operation Successfull', {
          position: 'top-center',
          autoClose: 1500,
        });
        setTimeout(() => window.location.reload(), 1500);
      })
      .catch(() => {
        toast.error('Operation Failed', {
          position: 'top-center',
          autoClose: 1500,
        });
      });
  };

  const abandonedCartLineItems = (data) => {
    if (typeof data.items === 'string') {
      data.items = data.items.replaceAll('True', 'true');
      data.items = data.items.replaceAll('False', 'false');
      data.items = data.items.replaceAll('None', 'null');
      // data.items = data.items.replaceAll("'", '"')
      const regex = /('(?=(,\s*')))|('(?=:))|((?<=([:,]\s*))')|((?<={)')|('(?=}))/g;
      data.items = data.items.replace(regex, '"');
    }
    try {
      let items = typeof data.items === 'string' ? JSON.parse(data.items) : [...data.items];
      let lineItems = [];
      for (let k = 0; k < items.length; k++) {
        let current = items[k];
        let temp;
        let ptitle = current.product_title != null ? current.product_title : '';
        let vtitle = current.variant_title != null ? current.variant_title : '';
        let quantity = current.quantity != null ? current.quantity : '';
        temp = '#' + ptitle + '(' + vtitle + ')' + '*' + quantity;
        lineItems.push(temp);
      }
      return lineItems.map((each) => <p key={each}>{each}</p>);
    } catch (error) {
      console.log(error);
    }
  };

  const imageURL = (data) => {
    if (data == null) return '/images/red.png';

    let keys = Object.keys(data);
    let cod = keys.includes('cod') ? data.cod : false;
    let upi = keys.includes('upi') ? data.upi : false;
    let plugin = keys.includes('plugin') ? data.plugin : false;

    if (plugin) {
      if (cod && upi) return '/images/green.png';
      else if (cod || upi) return '/images/yellow.png';
      else return '/images/red.png';
    } else return '/images/red.png';
  };
  const tooltipText = (data, type) => {
    if (type != 'magento' && type != 'woocommerce') {
      return;
    }
    if (data == null) return 'COD & UPI Disabled';

    let keys = Object.keys(data);
    let cod = keys.includes('cod') ? data.cod : false;
    let upi = keys.includes('upi') ? data.upi : false;
    let plugin = keys.includes('plugin') ? data.plugin : false;

    if (plugin) {
      if (cod && upi) return 'COD & UPI Enabled';
      else if (cod || upi) {
        if (cod) return 'COD Enabled';
        else return 'UPI Enabled';
      } else return 'COD & UPI Disabled';
    } else return 'COD & UPI Disabled';
  };

  const formatFileName = (file, id) => {
    let temp = `merchant/${id}/historicalData/`;
    let final = file.replace(temp, '');
    return final;
  };

  const OpenModal = () => {
    document.getElementById('go-modal').classList.add('open');
  };
  const [rejectNotePopUP, setRejectNotePopUP] = useState(false);
  const [rejectNote, setRejectNote] = useState('');

  // const [rejectNote, setRejectNote] = useState("");
  const appoveReject = async (val, id) => {
    setHistoricalDataID(id);
    let temp = {
      status: val.toLowerCase(),
    };
    if (val == 'REJECTED') {
      setRejectNotePopUP(true);
      // alert("some");
      // OpenModal();
    } else {
      axios
        .post(process.env.BASE_URL + `/api/merchant/historical-data/${id}`, temp, {
          headers: headers,
        })
        .then((res) => {
          setSearchFlag((flag) => !flag);
          toast.success('Status Updated', {
            autoClose: 1500,
            position: 'top-center',
          });
          console.log('Response', res);
        })
        .catch(() => {});
    }
  };

  const bankStatusConditioning = (status) => {
    let finalStatus = '';
    if (status === 'payment_successful') finalStatus = 'Completed';
    else if (['pending', 'timeout', 'payment_initiated'].includes(status)) {
      if (from === 'transactions') {
        finalStatus = status === 'payment_initiated' ? 'User Dropped' : status;
      } else {
        finalStatus = 'Initiated';
      }
    } else if (status === 'payment_failed') finalStatus = 'Failed';
    else finalStatus = status;
    return finalStatus;
  };

  useEffect(() => {
    // alert("hello");
    // alert(rejectNotePopUP);
    if (rejectNotePopUP) {
      // alert("hi");
      OpenModal();
    }
  }, [rejectNotePopUP]);

  const rejectNoteExpand = (note) => {
    setRejectNotePopUP(false);
    setRejectNote(note);
    OpenModal();
  };

  const handleHistoricalPopUp = () => {
    if (rejectNotePopUP) {
      return (
        <AddRejectNote id={historicalDataID} setSearchFlag={setSearchFlag} setRejectNotePopUP={setRejectNotePopUP} />
      );
    } else {
      return <ExpandRejectNote note={rejectNote} />;
    }
  };

  const formatCustomerMerchantBlocked = (value) => {
    if (value == null || value == '') {
      return <p></p>;
    }
    return value.map((u) => (
      <p>
        {u?.merchant?.short_name} {u?.type ? u?.type : 'All'}
      </p>
    ));
  };
  const formatCustomerPlatformBlocked = (value) => {
    if (value == null || value == '') {
      return <p></p>;
    }
    return value.map((u) => (
      <p>
        {u?.platform} {u?.type ? u?.type : 'All'}
      </p>
    ));
  };

  const downloadHistoricalData = async (url, id) => {
    try {
      let res = await axios.get(process.env.BASE_URL + `/api/utility/download?url=${url}`, {
        headers: {
          authorization: localStorage.getItem('token'),
        },
        params: { size: 'big' },
      });
      console.log('Download File', res);
      let base64 = res.data.data;
      // const base64 = btoa(
      //   new Uint8Array(res.data.data.file.data).reduce(
      //     (data, byte) => data + String.fromCharCode(byte),
      //     ""
      //   )
      // );
      window.location.href = base64;
      // console.log(base64);
      // let csvContent = atob(base64);
      // let csvContent = base64;
      // let csvContent;
      // var blob = new Blob([csvContent], {
      //   type: "data:application/octet-stream;base64",
      // });
      // var url1 = window.URL.createObjectURL(blob);
      // var pom = document.createElement("a");
      // pom.href = url1;
      // let temp = `merchant/${id}/historicalData/`;
      // let fileName = url.replace(temp, "");
      // pom.setAttribute("download", fileName);
      // pom.click();
    } catch (err) {
      console.log('downloadimg error', err);
    }
  };

  const DownloadReport = (id) => {
    axios
      .get(process.env.BASE_URL + `/api/reports/merchantReportUrl?id=${id}`, {
        headers: headers,
      })
      .then((res) => {
        if(res.status === 200){
          var link = document.createElement('a')
          link.download = "report"
          link.href = res.data.data.s3url
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      })
      .catch((err) => {
        toast.error('Download failed', {
          position: 'top-center',
          autoClose: 1500,
        });
      });
  };

  const DownloadBulkReport = (url) => {
    axios
      .get(process.env.BASE_URL + `/api/utility/download?url=${url}`, {
        headers: headers,
      })
      .then((res) => {
        let temp = res.data.data.file.data;
        const base64String = btoa(
          new Uint8Array(res.data.data.file.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
        const simple = atob(base64String);

        var refundIDArr = [];
        var lines = simple.split('\n');
        var result = [];
        var headers = lines[0].split(',');
        for (var i = 1; i < lines.length; i++) {
          var obj = {};

          var currentline = lines[i].split(',');
          for (var j = 0; j < headers.length; j++) {
            if (headers[j] === 'Refund ID') refundIDArr.push(currentline[j]);
            obj[headers[j]] = currentline[j];
          }
          result.push(obj);
        }

        // hamare ye result m ek array of obj m csv h
        refundIDArr = refundIDArr.filter((each) => each !== '');
        if (refundIDArr.length === 0) {
          var pom = document.createElement('a');
          var blob = new Blob([simple], { type: 'text/csv;charset=utf-8;' });
          var url = URL.createObjectURL(blob);
          pom.href = url;
          pom.setAttribute('download', 'BulkReport.csv');
          pom.click();
          toast.success('Downloaded successfully!', {
            position: 'top-center',
            autoClose: 1500,
          });
        } else AddRefundDetail([...refundIDArr], [...result]);
      })
      .catch((err) => {});
  };

  const AddRefundDetail = (refundID, result) => {
    axios
      .put(
        process.env.BASE_URL + `/api/refund/get-refund-details-by-rid`,
        {
          refund_ids: refundID,
        },
        {
          headers: headers,
        }
      )
      .then((res) => {
        // alert('hi');
        const refundDatabyRid = res.data.message?.reduce(
          (acc, refund) => ({ ...acc, [refund.gokwik_rid]: { ...refund } }),
          {}
        );
        let isShopify = null;
        let final = [];
        for (let i = 0; i < result.length; i++) {
          if (isShopify === null) isShopify = Object.keys(result[i]).includes('Shopify Order Number');
          if (!result[i]['Refund ID'] || !refundDatabyRid[result[i]['Refund ID']]) {
            final[i] = {
              ...result[i],
              Amount: '',
              RefundedAt: '',
              ReferenceID: '',
              PaymentID: '',
              Status: '',
            };
            //delete final[i]['Refund ID'];
            continue;
          } else {
            let tempId = result[i]['Refund ID'];

            if (refundDatabyRid[tempId]) {
              final[i] = {
                ...result[i],
                Amount: refundDatabyRid[tempId].amount || '',
                RefundedAt: refundDatabyRid[tempId].bank_timestamp
                  ? new Date(refundDatabyRid[tempId].bank_timestamp).toLocaleString('en-IN', {
                      hour: 'numeric',
                      minute: 'numeric',
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour12: true,
                    })
                  : '',
                ReferenceID: refundDatabyRid[tempId].cust_ref_id || '',
                PaymentID: refundDatabyRid[tempId].payment_id || '',
                Status: refundDatabyRid[tempId].status || '',
              };
              // delete final[i]['Refund ID'];
            }
          }
        }

        let csvContent = `OrderNumber,${
          isShopify ? 'ShopifyOrderNumber' : 'MerchantOrderID'
        },RefundID,RefundAmount,Error,Amount,PaymentID,ReferenceID,RefundedAt,Status\r\n`;

        csvContent += final
          .map(
            (u) =>
              `${u['Order Number']},${isShopify ? u['Shopify Order Number'] : u['Merchant Order ID']},${
                u['Refund ID']
              },${u['Refund Amount']},${u['Error']},${u['Amount']},${u['PaymentID']},${u['ReferenceID']},${
                u['RefundedAt']
              },${u['Status']}`
          )
          .join('\r\n');
        csvContent += '\r\n';
        var pom = document.createElement('a');
        var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        var url = URL.createObjectURL(blob);
        pom.href = url;
        pom.setAttribute('download', 'BulkReport.csv');
        pom.click();
        toast.success('Downloaded successfully!', {
          position: 'top-center',
          autoClose: 1500,
        });
      })
      .catch((err) => {});
    // let reader = new FileReader();
    // reader.readAsText(e.target.files[0]);
    // reader.onload = (e) => {
    //   csv({
    //     noheader: true,
    //     output: 'csv',
    //   })
    //     .fromString(e.target.result)
    //     .then((csvRow) => {
    //       console.log('Testing CSV', csvRow);
    //     });
    // };
  };

  const switchActions = (col, u, i) => {
    switch (from) {
      case 'merchants':
        return (
          <td key={`${col}-${u[col]}`}>
            <div className='form-group d-flex justify-content-center metro-r mb-0'>
              <Link href='/merchants/edit/[id]' as={`/merchants/edit/${u.m_id}`}>
                {/* <Link href="/customers/view"> */}
                {/* <button className="blue-btn mr-3"> */}
                <svg
                  className='cursor-pointer'
                  width='25px'
                  height='24px'
                  viewBox='0 0 25 24'
                  version='1.1'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12,4.5 C7,4.5 2.73,7.61 1,12 C2.73,16.39 7,19.5 12,19.5 C17,19.5 21.27,16.39 23,12 C21.27,7.61 17,4.5 12,4.5 Z M12,17 C9.24,17 7,14.76 7,12 C7,9.24 9.24,7 12,7 C14.76,7 17,9.24 17,12 C17,14.76 14.76,17 12,17 Z M12,9 C10.34,9 9,10.34 9,12 C9,13.66 10.34,15 12,15 C13.66,15 15,13.66 15,12 C15,10.34 13.66,9 12,9 Z'
                    // id="🔹-Icon-Color"
                    fill='#004B8D'
                  ></path>
                </svg>

                {/* </button> */}
              </Link>
              {/* <button className="blue-btn"> */}
              {/* <svg
                                className="cursor-pointer ml-3"
                                width="30px"
                                height="30px"
                                viewBox="0 0 30 30"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6,19 C6,20.1 6.9,21 8,21 L16,21 C17.1,21 18,20.1 18,19 L18,9 C18,7.9 17.1,7 16,7 L8,7 C6.9,7 6,7.9 6,9 L6,19 Z M9.17,11.17 C9.56,10.78 10.19,10.78 10.58,11.17 L12,12.59 L13.42,11.17 C13.81,10.78 14.44,10.78 14.83,11.17 C15.22,11.56 15.22,12.19 14.83,12.58 L13.41,14 L14.83,15.42 C15.22,15.81 15.22,16.44 14.83,16.83 C14.44,17.22 13.81,17.22 13.42,16.83 L12,15.41 L10.58,16.83 C10.19,17.22 9.56,17.22 9.17,16.83 C8.78,16.44 8.78,15.81 9.17,15.42 L10.59,14 L9.17,12.58 C8.78,12.2 8.78,11.56 9.17,11.17 Z M15.5,4 L14.79,3.29 C14.61,3.11 14.35,3 14.09,3 L9.91,3 C9.65,3 9.39,3.11 9.21,3.29 L8.5,4 L6,4 C5.45,4 5,4.45 5,5 C5,5.55 5.45,6 6,6 L18,6 C18.55,6 19,5.55 19,5 C19,4.45 18.55,4 18,4 L15.5,4 Z"
                                  // id="🔹Icon-Color"
                                  fill="#004B8D"
                                ></path>
                              </svg> */}
              {/* </button> */}
            </div>
          </td>
        );
      case 'dangledTransactions':
        if (paymentMSConfig[u['Merchant.m_id']]?.payment_service)
          return (
            permissions.includes('refund_dangled_transactions') &&
            u.payment_provider !== 'setu' &&
            u.bank_status === 'payment_successful' &&
            u.remark !== 'Twice merchant callback for same transaction.' && (
              <td key={`${col}-${u[col]}`} className='action-column d-flex'>
                <button
                  onClick={() => refundInitiate(u)}
                  className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                >
                  Refund
                </button>
              </td>
            )
          );
        return null;
      case 'settlement':
        if (paymentMSConfig[u['Merchant.m_id']]?.payment_service)
          return (
            <>
              <td key={`${col}-${u[col]}`} className='action-column d-flex'>
                {permissions.includes('update_status_settlements') &&
                  ['pending', 'timeout', 'payment_initiated'].includes(u?.bank_status?.toLowerCase()) && (
                    <button
                      onClick={() => actionFunctions.update_status(u)}
                      className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                    >
                      Update Status
                    </button>
                  )}
                {permissions.includes('edit_settlements') &&
                  ['pending', 'timeout', 'payment_initiated'].includes(u?.bank_status?.toLowerCase()) && (
                    <button
                      onClick={() => (from == 'settlement' ? displayModal(u) : openModal(u))}
                      className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                    >
                      Edit
                    </button>
                  )}
                {from == 'settlement' &&
                permissions.includes('retry_settlements') &&
                u?.bank_status === 'payment_failed' ? (
                  <button
                    onClick={() => actionFunctions.retry_settlement(u)}
                    className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                  >
                    Retry
                  </button>
                ) : null}
              </td>
            </>
          );
        return null;
      case 'refund':
        // if (u.payment_provider === 'setu') return null;
        if (paymentMSConfig[u['Merchant.m_id']]?.payment_service)
          return (
            <>
              <td key={`${col}-${u[col]}`} className='action-column d-flex'>
                {permissions.includes('update_status_refunds') &&
                  ['pending', 'timeout', 'payment_initiated'].includes(u?.bank_status?.toLowerCase()) && (
                    <button
                      onClick={() => actionFunctions.update_status(u)}
                      className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                    >
                      Update Status
                    </button>
                  )}
                {permissions.includes('edit_refunds') &&
                  ['pending', 'timeout', 'payment_initiated'].includes(u?.bank_status?.toLowerCase()) && (
                    <button
                      onClick={() => openModal(u)}
                      className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                    >
                      Edit
                    </button>
                  )}
                {permissions.includes('early_refund') && 'payment_initiated' === u?.bank_status?.toLowerCase() && (
                  <button
                    onClick={() => actionFunctions.early_refund(u)}
                    className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                  >
                    Prioritize Refund
                  </button>
                )}
              </td>
            </>
          );
        return null;
      case 'transactions':
        if (paymentMSConfig[u['Merchant.m_id']]?.payment_service)
          return (
            <>
              <td key={`${col}-${u[col]}`} className='action-column d-flex'>
                {permissions.includes('update_status_transactions') &&
                  ['pending', 'timeout', 'payment_initiated'].includes(u?.bank_status?.toLowerCase()) && (
                    <button
                      onClick={() => actionFunctions.update_status(u)}
                      className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                    >
                      Update Status
                    </button>
                  )}
                {permissions.includes('edit_transactions') &&
                  ['pending', 'timeout', 'payment_initiated'].includes(u?.bank_status?.toLowerCase()) && (
                    <button
                      onClick={() => openModal(u)}
                      className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                    >
                      Edit
                    </button>
                  )}
              </td>
            </>
          );
        return null;
      case 'merchants-discount':
        const discountDeleteID = customData?.discountDelete?.id;
        const isDiscountIDSame = discountDeleteID === u.id;
        if (discountDeleteID && !isDiscountIDSame) return null;
        return (
          <>
            <td
              key={`${col}-${u[col]}`}
              style={{
                width: '120px',
                ...(isDiscountIDSame && data.length <= 3 && { height: '250px' }),
              }}
              className='action-column  poppins fw900 fs12 lh-18 ls-15 pos-rel z-4'
            >
              {(activeRow === u.id || isDiscountIDSame) && (
                <div className='width-100 d-flex justify-content-end align-items-center pos-rel'>
                  <section className='cursor-pointer' onClick={() => actionFunctions.edit(u)}>
                    <Image src={'/images/edit-green.svg'} width={'36px'} height={'36px'} />
                  </section>
                  <section className=' margin-l20 pos-rel z-1'>
                    <div className='cursor-pointer pos-rel z-5' onClick={() => actionFunctions.delete(u)}>
                      <Image src={'/images/trash-red.svg'} width={'36px'} height={'36px'} />
                    </div>
                    {isDiscountIDSame && customComponents.delete(i)}
                  </section>
                </div>
              )}
            </td>
          </>
        );
      case 'report-section':
        return (
          <>
            <td key={`${col}-${u[col]}`} className='action-column'>
              {/* {' '}
              {activeRow === u.id && */}
              {u['status'].toLowerCase() === 'complete' && (
                <section className='cursor-pointer d-flex justify-content-center'>
                  <a className='bg-sky-blue bora-50' onClick={() => DownloadReport(u.id)}>
                    <Image src={'/images/download-icon.svg'} width={'20'} height={'20'} />
                  </a>
                </section>
              )}
              {/* ) : u['status'].toLowerCase() === 'failed' ? (
                  <section
                    className='cursor-pointer d-flex justify-content-center'
                    onClick={() => actionFunctions.retry(u)}
                  >
                    <Image src={'/images/reset-blue.svg'} width={'20'} height={'20'} />
                  </section>
                ) : null)} */}
            </td>
          </>
        );
      case 'autoRefundTransactions':
        if (paymentMSConfig[u['Merchant.m_id']]?.payment_service)
          return (
            permissions.includes('view_auto_refund_transactions') && (
              <>
                <td key={`${col}-${u[col]}`} className='action-column d-flex'>
                  <button
                    onClick={() => actionFunctions.auto_refund(u)}
                    className='blue-btn text-white padding-x15 padding-y10 cursor-pointer nowrap margin-x10'
                  >
                    Auto Refund
                  </button>
                </td>
              </>
            )
          );
        return null;
      default:
        return (
          <td key={`${col}-${u[col]}`}>
            <div className='form-group d-flex justify-content-center metro-r  mb-0'>
              <Link href='/customers/[id]' as={`/customers/${u.id}`}>
                {/* <td className="padding-t15 "> */}
                <svg
                  className='cursor-pointer'
                  width='25px'
                  height='24px'
                  viewBox='0 0 25 24'
                  version='1.1'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12,4.5 C7,4.5 2.73,7.61 1,12 C2.73,16.39 7,19.5 12,19.5 C17,19.5 21.27,16.39 23,12 C21.27,7.61 17,4.5 12,4.5 Z M12,17 C9.24,17 7,14.76 7,12 C7,9.24 9.24,7 12,7 C14.76,7 17,9.24 17,12 C17,14.76 14.76,17 12,17 Z M12,9 C10.34,9 9,10.34 9,12 C9,13.66 10.34,15 12,15 C13.66,15 15,13.66 15,12 C15,10.34 13.66,9 12,9 Z'
                    // id="🔹-Icon-Color"
                    fill='#004B8D'
                  ></path>
                </svg>
                {/* </td> */}
              </Link>
              {/* <td className="padding-t15 "> */}

              <svg
                className='margin-l15 cursor-pointer ml-3'
                onClick={() => deleteCustomer(u.id)}
                width='30px'
                height='30px'
                viewBox='0 0 30 30'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M6,19 C6,20.1 6.9,21 8,21 L16,21 C17.1,21 18,20.1 18,19 L18,9 C18,7.9 17.1,7 16,7 L8,7 C6.9,7 6,7.9 6,9 L6,19 Z M9.17,11.17 C9.56,10.78 10.19,10.78 10.58,11.17 L12,12.59 L13.42,11.17 C13.81,10.78 14.44,10.78 14.83,11.17 C15.22,11.56 15.22,12.19 14.83,12.58 L13.41,14 L14.83,15.42 C15.22,15.81 15.22,16.44 14.83,16.83 C14.44,17.22 13.81,17.22 13.42,16.83 L12,15.41 L10.58,16.83 C10.19,17.22 9.56,17.22 9.17,16.83 C8.78,16.44 8.78,15.81 9.17,15.42 L10.59,14 L9.17,12.58 C8.78,12.2 8.78,11.56 9.17,11.17 Z M15.5,4 L14.79,3.29 C14.61,3.11 14.35,3 14.09,3 L9.91,3 C9.65,3 9.39,3.11 9.21,3.29 L8.5,4 L6,4 C5.45,4 5,4.45 5,5 C5,5.55 5.45,6 6,6 L18,6 C18.55,6 19,5.55 19,5 C19,4.45 18.55,4 18,4 L15.5,4 Z'
                  // id="🔹Icon-Color"
                  fill='#004B8D'
                ></path>
              </svg>
              {/* </td> */}
            </div>
          </td>
        );
    }
  };

  const switchStatement = (col, i, u) => {
    switch (col) {
      case 'm_id':
        return (
          <td
            className='d-flex justify-content-center align-items-center'
            data-toggle='tooltip'
            data-placement='top'
            title={tooltipText(u['enable_status'], u['platform'])}
            key={`${col}-${u[col]}`}
          >
            {from === 'merchants' && permissions.includes('update_merchant') ? (
              <Link href='/merchants/edit/[id]' as={`/merchants/edit/${u.m_id}`}>
                <p className='cursor-pointer text-primary'>{u[col]}</p>
              </Link>
            ) : (
              u[col]
            )}
            {/* {console.log(imageURL(u["enable_status"]))} */}
          </td>
        );
      case 'order_number':
        return (
          <td
            className={`${'cursor-pointer text-primary'}`}
            onClick={() => (from === 'address' ? displayModal(u.Order.order_number) : displayModal(u[col]))}
            key={`${col}-${u[col]}`}
          >
            {from === 'address' ? u.Order.order_number : u[col]}
          </td>
        );
      // case 'order_number':
      //   return (
      //     <td onClick={() => from === 'refund' && ( from  === 'address' ? alert("") : displayModal(u[col]) )} className='cursor-pointer text-primary'>
      //       {from === "address" ? u.Order.order_number : u['order_number']}
      //     </td>
      //   );
      case 'file_path':
        return <td key={`${col}-${u[col]}`}>{formatFileNameBulkRefund(u[col], u.merchant_id)}</td>;
      case 'payment_method':
        return <td key={`${col}-${u[col]}`}>{u[col] === 'UPIIntent' ? 'UPI' : u[col]}</td>;
      case 'id':
        if (from === 'abc') {
          return (
            <Link href={`/abandoned-cart/${u[col]}`} key={`${col}-${u[col]}`}>
              <td className='cursor-pointer text-primary'>{u[col]}</td>
            </Link>
          );
        }

        return <td key={`${col}-${u[col]}`}>{u[col]}</td>;
      case 'is_active':
        return from === 'merchants' ? (
          u.platform === 'shopify' ? (
            <td key={`${col}-${u[col]}`}>
              <label className='switch'>
                <input
                  type='checkbox'
                  id='merchantIsActiveSwitch'
                  onClick={(e) => {
                    e.preventDefault();
                    // e.stopPropagation();
                    setMerchantID(u.id);
                    setEventObject(e.target.checked);
                    OpenIsActiveModal();
                  }}
                  checked={u.is_active}
                  readOnly
                />
                <span className='slider round'></span>
              </label>
            </td>
          ) : (
            <td key={`${col}-${u[col]}`}></td>
          )
        ) : from === 'merchants-discount' ? (
          <td key={`${col}-${u[col]}`}>
            <section className='d-flex justify-content-start align-items-center'>
              <div className={`circle ${u.is_active ? 'bg-d-green' : 'bg-orange'} bora-50`} />
              <p className={`${u.is_active ? 'text-d-green ' : 'text-orange'} text-d-green margin-l10`}>
                {u.is_active ? 'Active' : 'Inactive'}
              </p>
            </section>
          </td>
        ) : null;

      case 'threshhold_rto_flag':
        return from === 'merchants' && u?.Merchant_config && u?.Merchant_config['threshhold_rto_flag'] ? (
          <td key={`${col}-${u[col]}`}>
            <p>{u?.Merchant_config[col]?.length != 0 ? 'Yes' : 'No'}</p>
          </td>
        ) : (
          <td key={`${col}-${u[col]}`}>No</td>
        );

      case 'ab_control_enable':
        return from === 'merchants' ? (
          <td key={`${col}-${u[col]}`}>
            <p>{u?.ab_control_enable ? 'Yes' : 'No'}</p>
          </td>
        ) : (
          <td key={`${col}-${u[col]}`}></td>
        );

      case 'is_shadow_deployed':
        return from === 'merchants' ? (
          <td key={`${col}-${u[col]}`}>
            <p>{u?.is_shadow_deployed ? 'Yes' : 'No'}</p>
          </td>
        ) : (
          <td key={`${col}-${u[col]}`}></td>
        );
      case 'rto_go_live_date':
        return from === 'merchants' ? (
          <td key={`${col}-${u[col]}`}>
            <p>{dateFormatChange(u?.Merchant_config?.rto_go_live_date)}</p>
          </td>
        ) : (
          <td key={`${col}-${u[col]}`}></td>
        );
      case 'cod_charge':
        return from === 'merchants' ? (
          <td key={`${col}-${u[col]}`}>
            <p>{checkCodCharge(u?.Merchant_config?.rto_config) ? 'Yes' : 'No'}</p>
          </td>
        ) : (
          <td key={`${col}-${u[col]}`}></td>
        );
      case 'upi_percent':
        return from === 'merchants' ? (
          <td key={`${col}-${u[col]}`}>
            <p>{checkUpiPercent(u?.Merchant_config?.rto_config) ? 'Yes' : 'No'}</p>
          </td>
        ) : (
          <td key={`${col}-${u[col]}`}></td>
        );
      case 'is_blocked':
        return from === 'merchants' ? (
          u.platform === 'shopify' ? (
            <td key={`${col}-${u[col]}`}>
              <label className='switch'>
                <input
                  type='checkbox'
                  defaultChecked={u.is_blocked}
                  // checked={u.is_blocked ? true : false}
                />
                <span className='slider round'></span>
              </label>
            </td>
          ) : (
            <td></td>
          )
        ) : from === 'transactions' ? (
          <td key={`${col}-${u[col]}`}>{`${u[col]}`}</td>
        ) : (
          <td key={`${col}-${u[col]}`}>
            <label className='switch'>
              <input type='checkbox' defaultChecked={u.is_blocked} onChange={(e) => customerBlock(e, u.id)} />
              <span className='slider round'></span>
            </label>
          </td>
        );
      case 'actions':
        return switchActions(col, u, i);
      case 'last_login':
      case 'register_date':
      case 'created_at':
        return from == 'order_analytics' ? (
          <td key={`${col}-${u[col]}`} style={{ minWidth: '120px' }}>
            {dateChangeWithSeconds(u[col])}
          </td>
        ) : (
          <td key={`${col}-${u[col]}`} style={{ maxWidth: '115px' }}>
            {dateFormatChange(u[col])}
          </td>
        );
      case 'updated_at':
      case 'bank_timestamp':
      case 'payment_at':
      case 'settlement.bank_timestamp':
        return (
          <td key={`${col}-${u[col]}`} style={{ maxWidth: '115px' }}>
            {dateFormatChange(u[col])}
          </td>
        );

      case 'final_line_price':
      case 'final_price':
      case 'grand_total':
      case 'amount':
      case 'price':
      case 'total':
      case 'total_price':
      case 'total_discount':
        return <td>{numberWithCommas(parseFloat(u[col]).toFixed(2))}</td>;
      case 'abandoned_cart_line_items':
        return <td style={{ minWidth: '300px' }}>{abandonedCartLineItems(u)}</td>;
      case 'abc_url':
        return (
          <td className='cursor-pointer text-primary'>
            <a target='_blank' href={u[col] ? u[col] : ''}>
              {u[col] ? u[col] : ''}
            </a>
          </td>
        );
      case 'Address.address1':
        return <td key={`${col}-${u[col]}`}>{findAddress(u)}</td>;
      case 'Customer.firstname':
        return (
          <td key={`${col}-${u[col]}`}>
            {u['aid']
              ? nullToStr(u['Address.firstname'], true) + ' ' + nullToStr(u['Address.lastname'], true)
              : nullToStr(u['Customer.firstname'], true) + ' ' + nullToStr(u['Customer.lastname'], true)}
          </td>
        );
      case 'Customer.email':
        return (
          <td key={`${col}-${u[col]}`}>
            {u['aid'] ? nullToStr(u['Address.email'], true) : nullToStr(u['Customer.email'], true)}
          </td>
        );
      case 'file': {
        return from === 'historicalData' ? (
          <td key={`${col}-${u[col]}`}>{formatFileName(u[col], u.merchant_id)}</td>
        ) : (
          ''
        );
      }
      case 'uploaded': {
        return from === 'historicalData' ? <td key={`${col}-${u[col]}`}>{u[col] ? u[col].name : ''}</td> : '';
      }
      case 'merchant': {
        return from === 'historicalData' ? <td>{u[col] ? u[col].short_name : ''}</td> : <td>{u[col]}</td>;
      }
      case 'reject_note': {
        return from === 'historicalData' ? (
          <td key={`${col}-${u[col]}`}>
            {u[col] != null && u[col].length > 50 ? (
              <span>
                {u[col].slice(0, 49)}
                <span className='text-primary cursor-pointer' onClick={() => rejectNoteExpand(u[col])}>
                  ...more
                </span>
              </span>
            ) : (
              u[col]
            )}
          </td>
        ) : (
          ''
        );
      }
      case 'refund_request_description': {
        return from === 'refund' ? (
          <td key={`${col}-${u[col]}`}>
            {u[col] != null && u[col].length > 50 ? (
              <span>
                {u[col].slice(0, 49)}
                <span className='text-primary cursor-pointer' onClick={() => setRefundDescription(u[col])}>
                  ...more
                </span>
              </span>
            ) : u[col] !== 'unknown' ? (
              u[col]
            ) : (
              ''
            )}
          </td>
        ) : (
          ''
        );
      }
      case 'approveReject': {
        return from === 'historicalData' ? (
          <td key={`${col}-${u[col]}`}>
            {u.status == 'VERIFIED' || u.status === 'REJECTED' ? (
              u.status.toUpperCase()
            ) : (
              <select
                className='form-control arrow-btn'
                id='abEnable'
                value={u.status}
                onChange={(e) => appoveReject(e.target.value, u.id)}
              >
                <option className='placeholder' value='PENDING' selected disabled hidden>
                  Pending
                </option>
                <option value='REJECTED'>Reject</option>
                <option value='VERIFIED'>Verify</option>
              </select>
            )}
          </td>
        ) : (
          ''
        );
      }
      case 'merchant_blocked':
        return <td key={`${col}-${u[col]}`}>{formatCustomerMerchantBlocked(u[col])}</td>;
      case 'platform_blocked':
        return <td key={`${col}-${u[col]}`}>{formatCustomerPlatformBlocked(u[col])}</td>;
      case 'firstname':
        return (
          <td key={`${col}-${u[col]}`} style={{ textTransform: 'capitalize' }}>
            {u.firstname != null ? u.firstname : ''} {u.lastname != null ? u.lastname : ''}
          </td>
        );

      case 'business_name':
        switch (from) {
          case 'refund':
          case 'bulkRefund':
            return <td key={`${col}-${u['Merchant'][col]}`}>{u['Merchant'][col]}</td>;
          default:
            return (
              <td className='width-20' key={`${col}-${u[col]}`}>
                {u[col]}
              </td>
            );
        }

      case 'visibility': {
        return from === 'merchants-discount' ? (
          <td key={`${col}-${u[col]}`}>
            {u[col] === 'ONLY_WHEN_ELIGIBLE' ? 'Only When Eligible' : u[col] === 'ALWAYS' ? 'Always' : ''}
          </td>
        ) : (
          <td>{u[col]}</td>
        );
      }
      case 'user_type': {
        return from === 'merchants-discount' ? (
          <td key={`${col}-${u[col]}`} className={`${!u.visibility && 'text-disabled'}  `}>
            {u[col]}
          </td>
        ) : (
          <td>{u[col]}</td>
        );
      }
      case 'additional_details': {
        return from === 'merchants-discount' ? (
          <td key={`${col}-${u[col]}`}>
            {u?.additional_details && u?.additional_details?.bullet_points?.length > 0 ? (
              <ul className='padding-l15'>
                {u.additional_details.bullet_points.map((point, index) => (
                  <li style={{ 'font-size': '12px' }} key={index}>
                    {point}
                  </li>
                ))}
              </ul>
            ) : (
              ''
            )}
          </td>
        ) : (
          <td>{u[col]}</td>
        );
      }
      case 'min_price': {
        return from === 'merchants-discount' ? (
          <td className={`${!u.visibility && 'text-disabled'}  `} key={`${col}-${u[col]}`}>
            {u[col] ? +u[col] : 0}
          </td>
        ) : (
          <td>{u[col]}</td>
        );
      }

      case 'max_price': {
        return from === 'merchants-discount' ? (
          <td className={`${!u.visibility && 'text-disabled'}  `} key={`${col}-${u[col]}`}>
            {u[col] ? +u[col] : null}
          </td>
        ) : (
          <td>{u[col]}</td>
        );
      }
      case 'downloadCsv':
        return from === 'historicalData' ? (
          <td key={`${col}-${u[col]}`}>
            <button className='blue-btn' onClick={() => downloadHistoricalData(u.file, u.merchant_id)}>
              Download
            </button>
          </td>
        ) : null;
      case 'action':
        switch (from) {
          case 'bulkRefund':
            if (!permissions.includes('bulk_refund_download')) return null;
            return (
              <td key={`${col}-${u[col]}`}>
                <div className='form-group d-flex metro-r mb-0'>
                  <button className='blue-btn' onClick={() => DownloadBulkReport(u.file_path)}>
                    Download
                  </button>
                </div>
              </td>
            );
        }
      case 'refund_request_file':
        return (
          <td
            key={`${col}-${u[col]}`}
            className='cursor-pointer text-primary'
            onClick={() => u[col] && downloadSourceFile(u[col])}
          >
            {u[col] && u[col] !== 'unknown' ? (
              <svg
                className='cursor-pointer'
                width='25px'
                height='24px'
                viewBox='0 0 25 24'
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12,4.5 C7,4.5 2.73,7.61 1,12 C2.73,16.39 7,19.5 12,19.5 C17,19.5 21.27,16.39 23,12 C21.27,7.61 17,4.5 12,4.5 Z M12,17 C9.24,17 7,14.76 7,12 C7,9.24 9.24,7 12,7 C14.76,7 17,9.24 17,12 C17,14.76 14.76,17 12,17 Z M12,9 C10.34,9 9,10.34 9,12 C9,13.66 10.34,15 12,15 C13.66,15 15,13.66 15,12 C15,10.34 13.66,9 12,9 Z'
                  // id="🔹-Icon-Color"
                  fill='#004B8D'
                ></path>
              </svg>
            ) : (
              ''
            )}
          </td>
        );
      case 'product_type':
      case 'merchant_device':
      case 'platform_tags':
        return (
          <td key={`${col}-${u[col]}`}>
            {u['merchant_tracker'] &&
            u['merchant_tracker'][col] &&
            Array.isArray(u['merchant_tracker'][col]) &&
            u['merchant_tracker'][col].length
              ? u['merchant_tracker'][col].join(', ')
              : ''}
          </td>
        );
      case 'merchant_name':
        return <td key={`${col}-${u[col]}`}>{(u['Merchant'] && u['Merchant']['short_name']) || ''}</td>;
      case 'customer_name':
        return (
          <td key={`${col}-${u[col]}`}>
            {(u['Order'] && u['Order']['billing_first_name'] + ' ' + u['Order']['billing_last_name']) || ''}
          </td>
        );

      case 'merchant_status':
        return <td key={`${col}-${u[col]}`}>{(u['merchant_tracker'] && u['merchant_tracker'][col]) || ''}</td>;
      case 'website':
        return (
          <td key={`${col}-${u[col]}`}>
            {u[col] && (
              <a
                href={u[col].includes('https') ? u[col] : `https://${u[col]}`}
                target='_blank'
                className='fw500 text-lt-blue fs12 lh-18 poppins'
              >
                {u[col]}
              </a>
            )}
          </td>
        );
      case 'merchant_businesses':
        return (
          from === 'payment-provider' && (
            <td key={`${col}-${JSON.stringify(u[col])}`}>
              {
                <ProviderDropDownInput
                  keyName='updatedPaymentProvider'
                  options={u[col]}
                  data={data}
                  setData={setData}
                  rowCheck={bodyCheck}
                  index={i}
                  placeholder='Select Provider'
                />
              }
            </td>
          )
        );

      case 'upi_payment_method':
        return <td key={`${col}-${u[col]}`}>{u['Merchant_config'] && u['Merchant_config'][col]}</td>;

      case 'check':
        return null;
      case 'remark':
        return (
          <td className='dangledTransaction-remark' key={`${col}-${u[col]}`}>
            {u[col]}
          </td>
        );
      case 'discount_code':
        return (
          <td key={`${col}-${u[col]}`}>
            <p className='padding-x10 padding-y7 bora-4 negative-ls-2'>{u[col]}</p>
          </td>
        );
      case 'bank_status':
        return (
          <td key={`${col}-${u[col]}`} className='capitalize'>
            {bankStatusConditioning(u[col])}
          </td>
        );
      case 'showComment':
        return <td style={{ minWidth: '300px' }}>{u[col]}</td>;
      case 'data':
        return (
          from == 'order_analytics' && (
            <td style={{ minWidth: '500px' }} key={`${col}-${u[col]}`}>
              <p className='padding-x10 padding-y7 bora-4 negative-ls-2'>
                <ShowMoreButton text={JSON.stringify(u[col]) || ''} trimLength={100} />
              </p>
            </td>
          )
        );
      case 'extra_data':
        return (
          from == 'order_analytics' && (
            <td style={{ minWidth: '300px' }} key={`${col}-${u[col]}`}>
              <p className='padding-x10 padding-y7 bora-4 negative-ls-2'>
                <ShowMoreButton text={JSON.stringify(u[col]) || ''} trimLength={100} />
              </p>
            </td>
          )
        );
      case 'user_agent':
        return (
          from == 'order_analytics' && (
            <td style={{ minWidth: '300px' }} key={`${col}-${u[col]}`}>
              <p className='padding-x10 padding-y7 bora-4 negative-ls-2'>
                <ShowMoreButton text={u[col] || ''} trimLength={100} />
              </p>
            </td>
          )
        );
      case 'status':
        return (
          <td key={`${col}-${u[col]}`}>
            {from === 'report-section' ? (
              <p
                className={`${
                  u[col].toLowerCase() === 'complete'
                    ? 'text-d-green'
                    : u[col].toLowerCase() === 'failed'
                    ? 'text-d-red'
                    : 'text-orange'
                }`}
              >
                {`${
                  u[col].toLowerCase() === 'complete'
                    ? 'Success'
                    : u[col].toLowerCase() === 'failed'
                    ? 'Error'
                    : 'Processing...'
                }`}
              </p>
            ) : (
              u[col]
            )}
          </td>
        );
      case 'model':
        return from == 'order_analytics' ? (
          <td style={{ minWidth: '200px' }}>{u[col]}</td>
        ) : from == 'payment-provider-model' ? (
          <td>{customComponents.model(u)}</td>
        ) : (
          <td>{u[col]}</td>
        );
      case 'os':
        return from == 'order_analytics' && <td style={{ minWidth: '100px' }}>{u[col]}</td>;
      case 'isp':
        return from == 'order_analytics' && <td style={{ minWidth: '200px' }}>{u[col]}</td>;
      case 'session_id':
        return from == 'order_analytics' && <td style={{ minWidth: '300px' }}>{u[col]}</td>;
      case 'is_checkout_healthy':
        return u[col] !== null ? (
          <div className='padding-l15'>
            <div className={`${!permissions.includes('update_shopify_merchant_health') && 'opacity-25'} `}>
              <div className='d-flex justify-content-center margin-t4'>
                <label className='switch '>
                  <input
                    type='checkbox'
                    checked={u[col]}
                    value={u[col]}
                    disabled={!permissions.includes('update_shopify_merchant_health')}
                    onChange={(e) => {
                      actionFunctions(u['merchant_id'], !u[col]);
                    }}
                  />
                  <span className='slider round'></span>
                </label>
              </div>
            </div>
          </div>
        ) : (
          <div className='padding-l15'>N/A</div>
        );
      case 'generatedOn':
        return (
          <td>
            {new Date(u[col]).toLocaleTimeString([], {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })}
          </td>
        );
      case 'dateRange':
        return <td>{stringMonthDate(u[col].from, u[col].to)}</td>;
      default:
        return <td key={`${col}-${u[col]}`}>{typeof u[col] == 'boolean' ? (u[col] ? 'true' : 'false') : u[col]}</td>;
    }
  };

  const checkCodCharge = (rto_config) => {
    let cod_charge = false;
    rto_config?.every((itm) => {
      if (itm.cod_charge != 0) {
        cod_charge = true;
        return true;
      }
    });
    return cod_charge;
  };
  const checkUpiPercent = (rto_config) => {
    let upi_percent = false;
    rto_config?.every((itm) => {
      if (itm.upi_percent != 0) {
        upi_percent = true;
        return true;
      }
    });
    return upi_percent;
  };

  return (
    <>
      <div className={`datatable  bg-white bora-12 width-100 ${newDesign && 'border-collapse'}`}>
        <div
          className={`d-flex ${
            from === 'merchants-discount' && 'justify-content-between'
          } align-items-center width-100`}
        >
          {from === 'merchants-discount' && customComponents.search()}
          {page && pageSize && (
            <div
              className={`row ${
                from === 'merchants-discount'
                  ? 'justify-content-center'
                  : 'justify-content-between width-100 padding-l20'
              }`}
            >
              <div className=''>
                <span className='fs14 lh-14 text-l-blue metro-r margin-r15'>Results per page:</span>
                <select
                  onChange={(e) => {
                    setPageSize(parseInt(e.target.value));
                    setPage(1);
                  }}
                  className='results-count text-blue arrow-btn'
                  value={String(pageSize)}
                >
                  <option value='25'>25</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                </select>
              </div>
              <div className='d-flex justify-content-end align-items-center margin-l20'>
                <span className='fs14 lh-14 text-l-blue metro-r margin-r15'>Total: {totalCount}</span>
                <Pagination
                  next={next}
                  displayPages={displayPages}
                  pageNumbers={pageNumbers}
                  page={page}
                  setPage={setPage}
                  pages={pages}
                  previous={previous}
                />
              </div>
            </div>
          )}
        </div>
        {!pageSize && !page && totalCount && (
          <div className='width-100 d-flex justify-content-end'>
            <span className='fs14 lh-14 text-l-blue metro-r margin-r15'>Total : {totalCount}</span>
          </div>
        )}
        <div className={`table-wrap ${newDesign && 'margin-t30'}`}>
          <table className='data-table  mr-20  mr-b20'>
            <thead>
              <tr
                className={`${
                  newDesign
                    ? 'text-label-grey fw400 fs14 lh-19 noto-sans'
                    : ['merchants', 'pincodes'].includes(from)
                    ? 'bg-yellow-orange-gradient bora-6 '
                    : ''
                } `}
              >
                {showMore ? (
                  colomnsName.map((col, i) => (
                    <th
                      key={col}
                      className={`${
                        newDesign
                          ? 'fw400'
                          : ['merchants', 'pincodes', 'payment-provider'].includes(from)
                          ? 'text-b-black fw700 fs12 lh-18 poppins bg-yellow-orange-gradient opacity-1'
                          : 'fs14 lh-14 metro-m text-l-blue'
                      }  text-center ${col === 'Remarks' && 'dangledTransaction-remark'}`}
                    >
                      {col === 'check' ? (
                        <div className='padding-l15'>
                          <CheckRadioButton
                            type='checkbox'
                            name={`${col}-${from}`}
                            isChecked={data.length === rowsChecked.length}
                            handleChange={allCheck}
                          />
                        </div>
                      ) : (
                        <p className={`${i === 0 && 'padding-l10'} padding-y10`}>{col}</p>
                      )}
                    </th>
                  ))
                ) : (
                  <>
                    {colomnsName.slice(0, 10).map((col, i) => (
                      <th
                        key={col}
                        className={`${
                          ['merchants', 'pincodes', 'payment-provider'].includes(from)
                            ? 'text-b-black fw700 fs12 lh-18 poppins bg-yellow-orange-gradient opacity-1'
                            : 'fs14 lh-14 metro-m text-l-blue'
                        }  text-center`}
                      >
                        {col === 'check' ? (
                          <div className='padding-l15'>
                            <CheckRadioButton
                              type='checkbox'
                              name={`${col}-${from}`}
                              isChecked={data.length === rowsChecked.length}
                              handleChange={allCheck}
                            />
                          </div>
                        ) : (
                          <p className={`${i === 0 && 'padding-l10'} padding-y10`}>{col}</p>
                        )}
                      </th>
                    ))}
                    {colomnsName.includes('Actions') && (
                      <th
                        key={'action'}
                        className={`${
                          ['merchants', 'pincodes', 'payment-provider'].includes(from)
                            ? 'text-b-black fw700 fs12 lh-18 poppins bg-yellow-orange-gradient opacity-1'
                            : 'fs14 lh-14 metro-m text-l-blue'
                        }  text-center`}
                        width={'120px'}
                      >
                        <p className={`padding-y10`}>Actions</p>
                      </th>
                    )}
                  </>
                )}
                {!hideShowMore && colomnsName.length >= 10 && (
                  <th>
                    <p className='showMore cursor-pointer' onClick={() => setShowMore(!showMore)}>
                      Show {showMore ? 'Less' : 'More'}
                    </p>
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {data.map((u, i) => (
                <tr
                  className={` ${newDesign && `noto-sans padding-y10`} ${
                    ['merchants', 'pincodes', 'payment-provider'].includes(from) && i % 2 === 0 && 'bg-l-grey bora-6'
                  } text-center ${from === 'payment-provider' && u.error && 'text-red'} ${
                    from === 'report-section' &&
                    (new Date().getTime() - new Date(u.generatedOn).getTime()) / 1000 < 30 &&
                    `animate-bg-${u.status.toLowerCase()}`
                  } `}
                  key={`${u}-${i}`}
                  onMouseEnter={() => ['merchants-discount', 'report-section'].includes(from) && setActiveRow(u.id)}
                  onMouseLeave={() => ['merchants-discount', 'report-section'].includes(from) && setActiveRow(null)}
                >
                  {from === 'merchants-discount' && customData?.editbannerData?.id === u.id ? (
                    <td className='edit-wrapper-bg' colSpan={colomnsName.length}>
                      {customComponents.edit()}
                    </td>
                  ) : (
                    <>
                      {colomns.includes('check') && (
                        <td className=''>
                          <div className='padding-l15'>
                            <CheckRadioButton
                              type='checkbox'
                              name={`${u.m_id}-${from}`}
                              isChecked={u.checked}
                              handleChange={(e) => {
                                bodyCheck(e.target.checked, u.m_id);
                              }}
                            />
                          </div>
                        </td>
                      )}
                      <td>{(pageSize || 0) * (page - 1 || 0) + i + 1}</td>
                      {showMore || hideShowMore ? (
                        colomns.map((col) => switchStatement(col, i, u))
                      ) : (
                        <>
                          {colomns.slice(0, 9).map((col) => switchStatement(col, i, u))}
                          {colomnsName.includes('Actions') && switchActions('actions', u)}
                        </>
                      )}
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {page && pageSize && (
          <div className='margin-t30 d-flex justify-content-end align-items-center'>
            <span className='fs14 lh-14 text-l-blue metro-r margin-r15'>Total: {totalCount}</span>
            <Pagination
              next={next}
              displayPages={displayPages}
              pageNumbers={pageNumbers}
              page={page}
              setPage={setPage}
              pages={pages}
              previous={previous}
            />
          </div>
        )}
      </div>
      {from === 'historicalData' ? handleHistoricalPopUp() : ''}
      {from === 'merchants' ? (
        <IsActiveModal setSearchFlag={setSearchFlag} id={merchantId} event={eventObject} />
      ) : null}
      {refundDescription && (
        <ExpandRefundDescription description={refundDescription} setDescription={setRefundDescription} />
      )}
    </>
  );
};

export default ReuseTable;
